export default function orangeReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_ORANGE":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
